const nl_popoverOptions = {
    content: function () {
        return $('#lp_AddSectionPopover').html();
    },
    trigger: 'click',
    animation: false,
    placement: 'top',
    container : '#lp_configurator',
    html: true,
    sanitize: false
};

const nl_popoverContentOptions = {
    content: function () {
        return $('#lp_AddCellContentPopover').html();
    },
    trigger: 'click',
    animation: false,
    placement: 'top',
    container : '#lp_configurator',
    html: true,
    sanitize: false
};


function reloadLandingPage() {

    if ($('#lp-dynamic-content').length == 0) {
        return;
    }
    $('.lp-add-section').each(function(){
        if ($(this).popover) {
            $(this).popover('dispose');
        }
    })

    $('.lp-add-cell-content').each(function(){
        if ($(this).popover) {
            $(this).popover('dispose');
        }
    })

    $('#lp-dynamic-content').load($('#lp-dynamic-content').data('url'), function () {
        $('.lp-add-section').popover(nl_popoverOptions);
        $('.lp-add-cell-content').popover(nl_popoverContentOptions);
        initSortableLandingPage();
        initFlatpickr('#lp_configurator');
        initSelect2('#lp_configurator')
    });
}

function initSortableLandingPage() {
    $('.sortableContainer').each(function(i, element){
        Sortable.create(element, {
            draggable: '.lp_section',
            sort: true,
            handle: '.lpMoveSection',
            group: 'landingpage',
            onAdd: function (event) {
                const data = {
                    oldPosition: event.oldIndex + 1,
                    newPosition: event.newIndex + 1,
                    fromPage: $(event.from).data('page'),
                    toPage: $(event.target).data('page')
                }

                const url = $(event.item).data('sort-url');

                axios.patch(url, data).then(function (resp) {
                    reloadLandingPage();
                })
            },
            onUpdate: function (event) {

                const data = {
                    oldPosition: event.oldIndex + 1,
                    newPosition: event.newIndex + 1,
                    fromPage: $(event.from).data('page'),
                    toPage: $(event.target).data('page')
                }

                const url = $(event.item).data('sort-url');

                axios.patch(url, data).then(function (resp) {
                    reloadLandingPage();
                })
            }
        });
    })
}

function recalcOptionNumbers() {
    $('#formOptionsContainer .lp-element-option-container').each(function(i) {
        $(this).find('.option-number').html(i + 1)
    })
}

$(document).ready(function(){
    // set popover to all 'add row' classes
    $('.lp-add-section').popover(nl_popoverOptions);

    $('#lp_configurator').on('click', '.lp-add-section', function(e) {
        e.preventDefault();

        if($(this).popover) {
            $(this).popover('hide')
        }

        window.insertAbovePosition = $(this).attr('data-position');
        window.insertSectionUrl = $(this).data('url');
    })

    $('body').on('click', 'a.popover-add-section', function(e) {
        e.preventDefault();

        let type = $(this).data('type');
        let position = window.insertAbovePosition;
        let url = window.insertSectionUrl;

        axios.post(url, {type: type, position: position}).then(function(response) {
            reloadLandingPage();
        }).catch(__defaultAxiosFailFunction);
    });

    $('body').on('click', '.lpDeleteSection', function(e) {
        e.preventDefault();

        let url = $(this).data('url');

        axios.delete(url).then(function(response) {
            reloadLandingPage();
        }).catch(__defaultAxiosFailFunction);
    });

    reloadLandingPage();
})

$(document).ready(function() {

    $('body').on('click', '.lp-add-cell-content', function(e) {
        e.preventDefault();
        let cellId = $(this).data('cell_id');
        window.cellId = cellId;

    })

    $('body').on('click', '.js-delete-cell-element', function (e) {
        e.preventDefault();

        let url = $(this).data('url');

        axios.delete(url).then(function (response) {
            reloadLandingPage();
            $('[data-bs-dismiss="modal"]').trigger('click');
        })
    })

    $('body').on('click', '#js-submit-lp-cell-dialog-form', function (e) {
        e.preventDefault();
        let form = $('#js-save-lp-cell-form');

        let data = form.serialize();



        if ($(this).data('type') == 'text') {

            data +=  '&text_content=' + encodeURIComponent(window.textElementEditor.getData());
        }

        axios.post(form.attr('action'), data).then(function (response) {
            reloadLandingPage();
            $('[data-bs-dismiss="modal"]').trigger('click');
        }).catch(__defaultAxiosFailFunction);


    })

    $('body').on('click', '.js-trigger-lp-modal', function(e) {
        e.preventDefault();

        $('.lp-add-cell-content').each(function(){
            if ($(this).popover) {
                $(this).popover('hide');
            }
        })

        let url = $(this).data('url');
        let header = $(this).data('header');
        let type = $(this).data('type');

        let cellId = $(this).data('cell_id') ?? window.cellId;

        let $trigger = '#ajaxContentModal';


        let bsModal = new bootstrap.Modal($trigger, {
            backdrop: 'static',
        })

        bsModal.show();

        let params = {
            cellId: cellId,
            type: type,
        }


        axios.get(url, {params}).then(function (response) {
            $($trigger + " .modal-body-placeholder").hide();
            $($trigger + " .modal-body-content").html(response.data).show();

            $($trigger + " .modal-title-placeholder").hide();
            $($trigger + " .modal-title-content").html(header).show();
        })
    })


    $(document).on('hide.bs.modal', function () {
        if ($('#lp-dynamic-content').length) {
            reloadLandingPage();
        }
    });

    $('body').on('keyup', 'textarea#helptext', function() {
        let length = $(this).val().length;
        $(this).parent().find('.word-count').html(length);
    })

    $('body').on('click', '.js-insert-lp-element-variable', function (e) {
        let content = $(this).data('content');
        let target = $('.lp-element-variable-target');

        $(target).val(target.val() + ' ' + content);
    })

    $('body').on('change', '#js-save-lp-cell-form #show_empty_text', function (e) {
        if ($(this).val() == '1') {
            $('#emptyTextContainer').show();
        } else {
            $('#emptyTextContainer').hide();
            $('#emptyTextContainer').find('input').val('');
        }
    })

    $('body').on('click', '.js-lp-element-remove-select-option', function(e) {
        e.preventDefault();
        if ($('#formOptionsContainer .lp-element-option-container').length == 1) {
            $.toast('Es muss mindestens eine Option verfügbar sein');
            return;
        }

        $(this).closest('.lp-element-option-container').remove();
        recalcOptionNumbers();
    })

    $('body').on('click', '.js-lp-cell-element-add-option', function(e) {
        e.preventDefault();
        let url = $(this).data('url');
        let position = $('#formOptionsContainer .lp-element-option-container').length + 1

        axios.get(url, {params: {position: position}}).then(function(response) {
            $('#formOptionsContainer').append(response.data);
        })
    })
})
